import { create } from 'zustand';
import { ReactNode } from 'react';

/**
 * Header Store
 *
 * Manages page-injected content for the app shell header.
 * Pages can set their title, context badge, and custom actions
 * which render in the TopBar component.
 */

interface HeaderState {
  // Page-specific content
  pageTitle: string | null;
  pageContext: string | null;
  headerActions: ReactNode | null;

  // Setters
  setPageTitle: (title: string | null) => void;
  setPageContext: (context: string | null) => void;
  setHeaderActions: (actions: ReactNode | null) => void;

  // Clear all page content (call on unmount)
  clear: () => void;
}

export const useHeaderStore = create<HeaderState>((set) => ({
  pageTitle: null,
  pageContext: null,
  headerActions: null,

  setPageTitle: (pageTitle) => set({ pageTitle }),
  setPageContext: (pageContext) => set({ pageContext }),
  setHeaderActions: (headerActions) => set({ headerActions }),

  clear: () => set({
    pageTitle: null,
    pageContext: null,
    headerActions: null
  }),
}));
